import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {BASE_URL} from '../constants';
import {Observable} from 'rxjs';
import {MatSnackBar} from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class RequestFileService {

  URL = BASE_URL + '/requestfile/';

  constructor(private http: HttpClient, private snackBar: MatSnackBar) { }

  public create(params: any): Observable<any>{
    return this.http.post(this.URL + 'create/', params);
  }

  public get(status: 'created' | 'files_added'): Observable<any>{
    let params = new HttpParams();
    params = params.append('status', status);
    return this.http.get(this.URL + 'list/', {params});
  }

  public validate(token: string, params): Observable<any> {
    return this.http.post(this.URL + 'validate/' + token + '/', params);
  }

  public exists(token: string): Observable<any> {
    return this.http.get(this.URL + 'exists/' + token + '/');
  }

  public delete(token: string): Observable<any> {
    return this.http.delete(this.URL + 'delete/' + token + '/');
  }

  public upload(token: string, formData: any): Observable<any> {
    return this.http.post(this.URL + 'upload/' + token + '/', formData, {
      reportProgress: true,
      observe: 'events'
    });
  }

  public download(token: string, queueId: string): Observable<any> {
    const params = {queue_id: queueId};
    return this.http.post(this.URL + 'download/' + token + '/', params, {observe: 'events', responseType: 'blob', reportProgress: true});
  }

  public resend_email(token: string): Observable<any> {
    return this.http.post(this.URL + 'resend_email/' + token + '/', {});
  }

  public copyLink(link: string){
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = link;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);

    this.snackBar.open('Link has been saved to clipboard!', 'close', {
      duration: 2000,
    });
  }

}
